import PreferencesSection from '@/components/user/settings/preferences/preferences-section';
import AccountSettingsPageShell from './AccountSettingsPageShell';
import { useProductAnalytics } from '@/components/analytics/ProductAnalyticsProvider';
import { Switch } from '@/components/ui/switch';
import { HStack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import SettingsSection from '../components/SettingsSection';

const AccountPreferencesSettingsPage = () => {
  const { t } = useTranslation();
  const { choice, busy, change, available } = useProductAnalytics();
  return (
    <AccountSettingsPageShell titleKey="settings.accountNav.preferences">
      <SettingsSection
        title={t('settings.accountPages.preferences.language')}
        description={t('settings.accountPages.preferences.description')}
        isLast={!available}
      >
        <PreferencesSection />
      </SettingsSection>
      {available ? (
        <SettingsSection
          title={t('settings.accountPages.preferences.privacy')}
          description={t('analytics.description')}
          isLast
        >
          <HStack justify="space-between" align="flex-start" gap="6">
            <Text fontWeight="medium">{t('analytics.title')}</Text>
            <Switch
              checked={choice === true}
              disabled={busy}
              colorPalette="primary"
              flexShrink={0}
              onCheckedChange={({ checked }) => change(Boolean(checked))}
              inputProps={{ 'aria-label': t('analytics.title') }}
            />
          </HStack>
        </SettingsSection>
      ) : null}
    </AccountSettingsPageShell>
  );
};

export default AccountPreferencesSettingsPage;
